import K9SeatView from "./component/k9_seat_view";
import K9TableModuleBase from "./k9_talbe_module_base";
import K9Help from "./component/k9_help";
import { K9SeatCfg } from "./component/k9_state_config";
import { K9 } from "./k9_data";
import { IUserData } from "../../../public/model_data";
import ModuleManager from "../../../../framework/core/module_manager";
import LanguageManager from "../../../../manager/language_manager";
import TableBaseView from "../../../table/module/table_base/table_base_view";
import K9TableView from "./k9_talbe_View";
import Utility from "../../../../utility/utility";

const {ccclass, property} = cc._decorator;

@ccclass
export default class K9SeatEntityBase {

    protected seatView:K9SeatView = null;

    parent:K9TableModuleBase = null;

    tableview:K9TableView = null;

    isSeat:boolean;//是否坐下

      //用于牌型的座位排序
    sortID:number;

     //服务器座位ID
    private _seatPos;

    get seatPos():number{
        return this._seatPos;
    }

    set seatPos(v:number){
        this._seatPos = v;
        //this.test(v+'');
    }

    //初始化赋值
    create(prefab:cc.Node,root:cc.Node){
        let seat = K9Help.AddChild(prefab,root)
        this.seatView = seat.getComponent(K9SeatView);
        //this.seatView.registerClickFunc(this.showChat.bind(this))
    }

    showChat(){
        let id = null;
        let data:K9.SeatData = null;
        if (this.seatPos == -1) {
            data=this.parent.getBankData();
        }else{
            data = this.parent.findSeatData(this.seatPos);
        }
        id = data.player_id;
        if (data && id != 0) {
            ModuleManager.instance.showEmojiModule(id,'K9TableModule')
        }
    }

    getSeatNode():cc.Node{
        return this.seatView.emotionNode;
    }

    getEffectNode():cc.Node{
        return this.seatView.effectNode;
    }

    protected noInGameState(data:K9.SeatData){

    }

    //开始发牌
    beginDealCard(){
        this.seatView.resetSmallPoker();
        this.seatView.cancleOperator();
        this.seatView.isShowName(true);
    }

    protected checkBetState(data:K9.SeatData,isNeedAck:boolean = true,isNeedAnim:boolean = true){
        if (this.parent.isBank(data.player_id)) {
            if (isNeedAck) {
                this.parent.sendAck();
            }
            this.updateBet(false);
        }else{
            this.updateBet(true,data.bet_coin,isNeedAnim,()=>{
                if (this.parent.isRole(data.player_id) && isNeedAck) {
                    this.parent.sendAck();
                }
            });
        }
        this.resetToIdel(data);
    }

    resetToIdel(data:K9.SeatData){
        if (!data) {
            return;
        }
        let avatar = this.tableview.getAvatarById(data.seat_pos);
        if (avatar) {
            avatar.refreshName(data.name);
            avatar.refreshCoinBalance(data.coin_balance);
        }
        this.seatView.cancleOperator();
        this.seatView.isShowName(true);
    }

    //爆牌
    beginOpenCardState(proto:K9.SeatData,isplay:boolean = true){

        if (!proto || proto.state == K9.PlayerState.NoInGame) {
            return;
        }

        if (this.isK8orK9(proto)) {
            this.seatView.resetSmallPoker();
            this.seatView.resetBigCards();
            this.seatView.tian8Show(proto,isplay);
            this.showPattern(false);
            this.resetToIdel(proto);
        }
    }

    //要牌
    protected giveCardsState(data:K9.SeatData){
        if (!data) {
            return;
        }
        let str = data.cards.length == 2 ? LanguageManager.t('k9_no_need_card'):LanguageManager.t('k9_need_card');
        this.seatView.cancleOperator();
        this.seatView.showOperator(true,str,data.cards.length == 3)
        this.seatView.isShowName(true);
    }

    updatePlayerInfo(data:K9.SeatData){
        if (!data) {
            return;
        }
        //this.seatView.updatePlayerInfo(data);
        this.updateInfo(data);
    }

    updateInfo(data:K9.SeatData){
        let avatar = this.tableview.getAvatarById(data.seat_pos);
        if (avatar) {
            avatar.refreshName(data.name);
            avatar.refreshCoinBalance(data.coin_balance);
        }
    }

    protected isShowMask(pos:number,isShow){
        let avatar = this.tableview.getAvatarById(pos);
        if (avatar) {
            avatar.showMask(isShow)
        }
    }

    //可操作
    protected operatorState(data:K9.SeatData){
        if (!data) {
            return;
        }
        
    }

    //步骤2亮牌
    settlementStep1(data:K9.SeatData){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        if (!this.isK8orK9(data)) {
            this.seatView.showPokers(data);
        }
        this.seatView.resetSmallPoker();
        this.seatView.resetBigCards();
        this.seatView.showPattern(false);
        this.seatView.showOperator(false);
        this.resetToIdel(data)
    }

    settlementStep2(data:K9.SeatData){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }

        if (data.balance < 0) {
            let balance = Math.abs(data.balance);
            if (balance > data.bet_coin) {//总输赢 大于 下注筹码
                this.updateBet(true,balance,true);
            }
        }
    }

    //步骤3 飞筹码
    settlementStep3(data:K9.SeatData,func:Function){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        //输家
        if (data.balance < 0) {
            this.seatView.stopUserAction(K9.ActionTag.guici1)
            let action = K9Help.delay(this.seatView.timer,()=>{
                this.guiChi(this.parent.getPotNode(),()=>{
                    if (func) {
                        func();
                    }
                })
                this.updateBet(false);
            },0.3)
            action.setTag(K9.ActionTag.guici1);
        }
    }

    //步骤3 飞筹码
    settlementStep4(data:K9.SeatData){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        if (data.balance > 0) {
            this.obtainBetEx(this.parent.getPotNode(),this.seatView.goldTarget,data.balance+data.bet_coin,()=>{
                this.updateBet(true,data.balance+data.bet_coin,false);
            })
        }
    }

    //获取筹码并飘风
    settlementStep5(data:K9.SeatData){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        if (data.balance > 0) {
            this.seatView.recycleAllBet();
            this.obtainBetEx(this.seatView.goldTarget,this.seatView.betEndNode,data.balance+data.bet_coin,()=>{
                
            })
            this.updateBet(false);
        }else{
        }
        this.seatView.showOperator(false);
        this.seatView.isShowName(true);
        this.seatView.grayPattern(data);
        

        let avatar = this.getAvatar(data.seat_pos);
        if (avatar) {
            avatar.playScoreChangeAnim()
        }
        this.seatView.setScore(true,data.real_balance,()=>{
            //this.seatView.isShowName(false);
        });//抽水之后的分数
    }



    settlementState(data:K9.SeatData,isNeedAnim?:boolean){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        this.beginOpenCardState(data,isNeedAnim)
        this.settlementStep1(data);
        this.settlementStep5(data);
    }

    setPosition(pos:cc.Vec2){
        this.seatView.node.setPosition(pos);
    }

    updateSeatInfo(cfg:K9SeatCfg){
        this.seatView.updateSeatInfo(cfg);
    }

    protected getData(v:number,ispos:boolean = true){
        return this.parent.findSeatData(v,ispos);
    }

    //玩家坐下
    playerDown(viewid:number){
        
    }

    setTime(time:number,totalTime:number){
        this.seatView.setOperatorTime(time,totalTime)
    }

    cancleOperator(){
        this.seatView.cancleOperator();
    }

    runAction(action: cc.Action){
        this.seatView.node.runAction(action);
    }

    test(content:string){
        this.seatView.test(content)
    }

    //初始化赋值
    onLoad(){
        this.resetUI()
        this.seatView.isHavePlayer(false);
        this.isSeat = false;
    }

    //初始化
    onShow(data:K9.SeatData){
        if (!data) {
            return;
        }
        this.isSeat = true;
        this.resetUI();
        this.seatView.isHavePlayer(true)
        this.tableview.removeAvatarById(this.seatPos);
        this.seatView.updatePoker(data.player_id);
        let avatar = this.tableview.getAvatarById(data.seat_pos);
        if (!avatar) {
            avatar = this.tableview.addAvatarById(data.seat_pos,data.player_id,this.seatView.avatarNode)
        }
        avatar.show(true,data.player_id);
        if (data.player_id == 0) {// ZJ
            avatar.refreshName(LanguageManager.t('k9_banker'));   
            avatar.refreshAvatar(this.seatView.sysImage);
        }else{
            let self = this;
            avatar.refreshName(data.name);
            avatar.setClickAvatarBtnListener(function () {
                Utility.playButtonSound()                
                self.showChat()              
            })
        }
        
        avatar.showCoinBalance(true);
        avatar.refreshCoinBalance(data.coin_balance);
        if (data.seat_pos == 0) {
            avatar.showMask(true);
        }else{
            avatar.showMask(data.state == K9.PlayerState.NoInGame);
        }

        //更新下注
        if (data.state != K9.PlayerState.NoInGame
            && data.state != K9.PlayerState.isBegin
            && data.state != K9.PlayerState.Settlement) {
            this.updateBet(true,data.bet_coin,false);
        }

        if (data.state == K9.PlayerState.Settlement) {
            this.settlementState(data,false);
        }else{
            if (data.state != K9.PlayerState.NoInGame) {
                if (data.cards.length > 0
                && !this.isK8orK9(data)) {
                    if (this.parent.isRole(data.player_id)) {
                        this.showBigCards(data.cards);
                        this.showPattern(true,data);
                    }else{
                        this.showSmallCards(data.cards)
                    }
                }
            }
            this.updateStateUI(data,false);
        }
    }

    getAvatar(seat_pos:number){
        return this.tableview.getAvatarById(seat_pos);
    }

    isK8orK9(data:K9.SeatData){
        if (!data) {
            return false
        }
        if(data.card_type == K9.CardType.K8
        || data.card_type == K9.CardType.K9)
        {
            return true;
        }
        return false;
    }

    moveToBankOver(){
        this.seatView.isHavePlayer(false);
    }

    //显示牌
    showSmallCards(cards:number[]){
        this.seatView.showSmallCards(cards);
    }

    updateBet(isShow:boolean,numb:number=0,isNeedAnim:boolean=true,func?:Function){
        this.seatView.updateBet(isShow,numb,isNeedAnim,func);
    }

    isBeginCard(isBegin:boolean){
        this.seatView.isBeginCard(isBegin);
    }

    //发牌
    dealCards(start:cc.Node,index:number,cards:number[]){
        if (!cards) {
            cc.warn('不存在cards!');
            return;
        }
        this.seatView.dealCards(start,index,cards);
    }

    //发牌 大牌可直接显示
    dealBigCards(startNode:cc.Node,index:number,cards:number[],isPlayGame?:boolean,comp?:Function){
        this.seatView.dealBigCards(startNode,index,cards,isPlayGame,comp)
    }

    //发牌结束
    dealOverCards(start:number,endNumb:number,func?:Function,isPlayGame?:boolean){
        this.seatView.dealOverCards(start,endNumb,func,isPlayGame);
    }

    delayOver(start:number,endNumb:number,func?:Function,isPlayGame?:boolean){
        this.seatView.dealyOver(start,endNumb,func,isPlayGame);
    }

    showPattern(isShow:boolean,data?:K9.SeatData){
        this.seatView.showPattern(isShow,data)
    }

    //归池
    guiChi(target:cc.Node,func?:Function){
        this.seatView.guiChi(target,func);
    }

    //玩家离开
    onLeave(){
        this.isSeat = false;
        this.tableview.removeAvatarById(this.seatPos);
        this.seatView.isHavePlayer(false);
        this.resetUI();
    }

    //更新玩家entity
    updateEntity(v_id:number,ispos:boolean = true){
        let data = this.getData(v_id,ispos);
        if (!data) {
            return;
        }
       this.updateStateUI(data);
       if (data.cards.length > 0) {
            if (this.parent.isRole(v_id)) {//更新牌型
                this.seatView.showPattern(!this.isK8orK9(data),data);
            }
       }
    }

    updateStateUI(data:K9.SeatData,isNeedAnim:boolean = true){
        if (!data) {
            return;
        }
        if (data.state == K9.PlayerState.CheckBet) {//下注
            this.checkBetState(data,isNeedAnim);
        }
        if (data.state == K9.PlayerState.BeginOpen) {//预开牌
            this.beginOpenCardState(data,isNeedAnim)
        }
        if (data.state == K9.PlayerState.Operator) {//要牌状态
            this.giveCardsState(data);
        }

    }


    showBigCards(cards:number[]){
        this.seatView.showBigCards(cards);
    }
    
    //获得bet
    obtainBet(target:cc.Node,gold:number,comp:Function){
        this.seatView.obtainBet(target,gold,comp);
    }

    obtainBetEx(target:cc.Node,endNode:cc.Node,gold:number,comp:Function){
        this.seatView.obtainBetEx(target,endNode,gold,comp);
    }

    //state
    updateTime(time:number,totalTime:number,data:K9.SeatData,state:number){
        if (!data) {
            return;
        }
        this.seatView.cancleOperator()
        if (state ==  K9.GameState.CheckBet
            || state == K9.GameState.Operator) {
                if (<number>data.state != state 
                    && data.state != K9.PlayerState.NoInGame) {
                    if (data.card_type == K9.CardType.K8 || data.card_type == K9.CardType.K9) {
                        this.seatView.setIdelState(1);
                        this.seatView.isShowName(true);
                    }else{
                        if (this.parent.isRole(data.player_id)) {
                            this.setTime(time,totalTime);
                            this.seatView.isPlayClock(true);
                            this.seatView.isShowName(true);
                            this.parent.updateTableState(state);
                        }else{
                            this.seatView.setIdelState(0);
                            this.seatView.isShowName(true);
                        }
                    }
                }
        }

        if (this.parent.isBank(data.player_id)) {//
            if (state ==  K9.GameState.CheckBet && this.parent.isRole(data.player_id)) {
                //取消下注
                this.seatView.setIdelState(1);
                this.parent.sendAck();
                this.parent.updateTableState(1);
                this.seatView.isShowName(true);
                this.seatView.cancleOperator()
            }
        }
    }

    //移动到banker
    moveToBank(pur:cc.Node,func:Function){
        this.seatView.moveToBank(pur,func);
    }

    //重置UI
    resetUI(){
       this.seatView.resetUI()
    }

    //重置并开始下一局
    restartNextRound(){
        //重置名字
        this.seatView.resetUI();;
        this.seatView.isShowName(true);
    }

    changeToBank(){
        this.seatView.isHavePlayer(false);
        this.isSeat = false;
    }
}
